import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  OverflowMenu,
  OverflowMenuItem,
  Tooltip
} from 'carbon-components-react';
import Icon from './Icon';

const DisplayAnnouncementsRow: React.FC<any> = ({
  row,
  getRowProps,
  handlePreviewEdit,
  handleMakeActive,
  handleDelete
}: any) => {
  const [openTooltipIcon, setOpenTooltipIcon] = useState(false);
  const [openTooltipType, setOpenTooltipType] = useState(false);

  const handleTooltipOver = (tooltipType: string) => {
    if (tooltipType === 'icon') {
      setOpenTooltipIcon(true);
    } else if (tooltipType === 'type') {
      setOpenTooltipType(true);
    }
  };

  const handleTooltipLeave = (tooltipType: string) => {
    if (tooltipType === 'icon') {
      setOpenTooltipIcon(false);
    } else if (tooltipType === 'type') {
      setOpenTooltipType(false);
    }
  };

  const generateTooltip = (noticeType: string, organisations: any) => {
    if (noticeType !== 'Member') {
      return noticeType;
    } else {
      const noOfOrgsToShow = 3;
      const totalOrgs = organisations.length;
      const topThreeOrgs = organisations.slice(0, noOfOrgsToShow);
      const more = totalOrgs - noOfOrgsToShow;

      return (
        <div className="type-tooltip-container">
          <Tooltip
            triggerText={noticeType}
            align="start"
            open={openTooltipType}
            onChange={() => handleTooltipOver('type')}
            showIcon={false}
            className={'custom-tooltip-size'}
          >
            <div id="tooltip-body">
              {topThreeOrgs.map((org: any) => {
                return (
                  <p
                    key={`${org.utilityId}`}
                  >{`${org.name} (${org.utilityId})`}</p>
                );
              })}
              {more > 0 && <p>and {more} more ...</p>}
            </div>
          </Tooltip>
        </div>
      );
    }
  };

  return (
    <TableRow {...getRowProps({ row })}>
      <TableCell key={row.cells[0].id} className="icon-cell">
        <div
          className="icon-container"
          onMouseOver={() => handleTooltipOver('icon')}
          onMouseLeave={() => handleTooltipLeave('icon')}
        >
          <Icon
            icon={row.cells[0].value}
            category={row.cells[0].category}
            type={row.cells[2].value}
            openTooltip={openTooltipIcon}
            handleTooltipOver={() => handleTooltipOver('icon')}
            organisations={row.cells[7].value}
          />
        </div>
      </TableCell>

      <TableCell key={row.cells[1].id}>{row.cells[1].value}</TableCell>

      <TableCell key={row.cells[2].id}>
        <div
          onMouseOver={() => handleTooltipOver('type')}
          onMouseLeave={() => handleTooltipLeave('type')}
        >
          {generateTooltip(row.cells[2].value, row.cells[7].value)}
        </div>
      </TableCell>

      <TableCell key={row.cells[3].id}>{row.cells[3].value}</TableCell>

      <TableCell key={row.cells[4].id}>{row.cells[4].value}</TableCell>

      <TableCell key={row.cells[5].id}>{row.cells[5].value}</TableCell>

      <TableCell key={row.cells[6].id}>
        <div
          className={
            row.cells[6].value === 'Ended'
              ? 'ended'
              : row.cells[6].value === 'Active'
              ? 'active'
              : 'scheduled'
          }
        >
          {row.cells[6].value}
        </div>
      </TableCell>

      <TableCell key="overflow" className="bx--table-column-menu">
        <OverflowMenu
          light
          flipped
          ariaLabel={'Options'}
          iconDescription={'Options'}
        >
          <OverflowMenuItem
            itemText="Preview / edit"
            onClick={() => handlePreviewEdit(row.id)}
          />
          <OverflowMenuItem
            itemText="Make active"
            onClick={() => handleMakeActive(row.id)}
            disabled={row.cells[6].value !== 'Scheduled'}
          />
          <div className="overflow-divider"></div>
          <OverflowMenuItem
            itemText={row.cells[6].value === 'Active' ? 'End now' : 'Delete'}
            onClick={() => handleDelete(row.id, row.cells[6].value)}
            disabled={row.cells[6].value === 'Ended'}
          />
        </OverflowMenu>
      </TableCell>
    </TableRow>
  );
};

DisplayAnnouncementsRow.displayName = 'DisplayAnnouncementsRow';
export default DisplayAnnouncementsRow;
